<template>
  <div class="px-4" style="min-height: 480px;">
    <v-form>
      <template v-if="(stateModule.typeId === moduleTypes.TU_HOC && stateModule.schoolLevelId === moduleSchoolLevel.TH && contactStatus === 'M')  && dataForm.isDetail">
        <validation-provider v-slot="{ errors }" name="Tên người liên hệ" rules="max:255">
          <v-text-field
              readonly
              v-model="computedFullName"
              label="Tên người liên hệ"
              :error-messages="errors"
              color="primary"
          />
        </validation-provider>
      </template>
      <template v-else>
        <validation-provider v-slot="{ errors }" name="Tên người liên hệ" rules="max:255">
          <v-text-field
              v-model="dataForm.customers[0].fullName"
              label="Tên người liên hệ"
              :error-messages="errors"
              color="primary"
          />
        </validation-provider>
      </template>
      <div class="d-flex align-center">
        <template v-if="(stateModule.typeId === moduleTypes.TU_HOC && stateModule.schoolLevelId === moduleSchoolLevel.TH && contactStatus === 'M')  && dataForm.isDetail">
          <validation-provider
              v-slot="{ errors }"
              name="SĐT liên hệ"
              :rules="{ required: true }"
              style="width: 100%"
          >
            <v-text-field
                :readonly="(!checkAuthorization('contact_update') && dataForm.isDetail) || true"
                v-model="computedPhoneNumber"
                label="SĐT liên hệ"
                :error-messages="errors"
                color="primary"
            />
          </validation-provider>
        </template>
        <template v-else>
          <validation-provider
              v-slot="{ errors }"
              name="SĐT liên hệ"
              :rules="{ regex: regex.isVNPhoneMobile, required: true }"
              style="width: 100%"
          >
            <v-text-field
                :readonly="!checkAuthorization('contact_update') && dataForm.isDetail"
                v-model="dataForm.customers[0].mobile"
                label="SĐT liên hệ"
                :error-messages="errors"
                color="primary"
            />
          </validation-provider>
        </template>
        <v-tooltip v-if="showChat" bottom>
          <template v-slot:activator="{ on }">
              <v-btn class="icon-fb" icon small color="info" v-on="on"><v-icon>mdi-facebook-messenger</v-icon></v-btn>
          </template>
          <span>Nhắn tin</span>
        </v-tooltip>
      </div>

      <div v-if="dataForm.contactType == 'main'">
<!--        <v-text-field-->
<!--          :value="listPhoneRelated"-->
<!--          :label="dataForm.contactType == 'main' ? 'SĐT phụ' : 'SĐT chính'"-->
<!--          @click="showMainContact()"-->
<!--          color="primary"-->
<!--          readonly-->
<!--          class="i-cursor"-->
<!--        />-->
        <template v-if="(stateModule.typeId === moduleTypes.TU_HOC && stateModule.schoolLevelId === moduleSchoolLevel.TH && contactStatus === 'M')  && dataForm.isDetail">
          <v-text-field
              :value="maskedPhoneNumber(listPhoneRelated)"
              :label="dataForm.contactType == 'main' ? 'SĐT phụ' : 'SĐT chính'"
              @click="showMainContact()"
              color="primary"
              readonly
              class="i-cursor"
          />
        </template>
        <template v-else>
          <v-text-field
              :value="listPhoneRelated"
              :label="dataForm.contactType == 'main' ? 'SĐT phụ' : 'SĐT chính'"
              @click="showMainContact()"
              color="primary"
              readonly
              class="i-cursor"
          />
        </template>
      </div>
      <div v-if="checkAuthorization('merge-contact_read')">
        <div v-if="!dataForm.mainId && dataForm.contactType == null && dataForm.id" class="merge-contact-btn" @click="showMergeModal = true">
          Gộp contact
        </div>
        <div v-else-if="dataForm.id" class="merge-contact-btn" @click="unmergeContact()">
          Bỏ gộp số
        </div>
      </div>
      <span>
        <label>Đối tượng liên hệ</label>
        <v-radio-group
          v-model="dataForm.customers[0].position"
          @change="changePosition()"
          row
        >
          <v-radio label="Con" value="child" />
          <v-radio label="Bố" value="father" />
          <v-radio label="Mẹ" value="mother" />
          <v-radio label="Khác" value="other" />
        </v-radio-group>
      </span>
      <span>
        <label>Điạ chỉ</label>
        <v-autocomplete
          v-model="dataForm.customers[0].tinhId"
          :items="provinces"
          item-text="ten"
          item-value="id"
          label="Tỉnh"
          @change="onChangeProvince"
          :filter="customFilterSearch"
        />
        <v-autocomplete
          v-model="dataForm.customers[0].huyenId"
          :items="districts"
          item-text="ten"
          item-value="id"
          label="Quận/Huyện"
          @change="onChangeDistrict"
          :filter="customFilterSearch"
        />
        <v-autocomplete
          v-model="dataForm.customers[0].xaId"
          label="Phường/Xã"
          :items="wards"
          item-text="ten"
          item-value="id"
          :filter="customFilterSearch"
        />
      </span>
      <validation-provider v-slot="{ errors }" name="Địa chỉ chi tiết" rules="max:255">
        <v-textarea
          :error-messages="errors"
          v-model="dataForm.customers[0].detailAddress"
          label="Địa chỉ chi tiết(số nhà, đường, thôn...)"
          rows="3"
        />
      </validation-provider>
      <template v-for="(contactColumn, indexContact) in contactColumnList">
        <v-text-field
          v-if="contactColumn.type === 'text'"
          :key="'indexContact_' + indexContact"
          v-model="dataForm.customers[0][contactColumn.id]"
          :label="contactColumn.description"
          color="primary"
        />
        <v-textarea
          v-else-if="contactColumn.type === 'textarea'"
          :key="'indexContact_' + indexContact"
          v-model="dataForm.customers[0][contactColumn.id]"
          :label="contactColumn.description"
          rows="2"
        />
      </template>
    </v-form>

    <v-dialog
      v-model="showMergeModal"
      max-width="500"
    >
      <v-card>
        <v-card-title class="font-weight-bold mb-0 d-flex justify-space-between">
          <span>Hãy nhập số chính để thực hiện gộp số</span>
          <v-btn
            color="default"
            @click="showMergeModal = false"
            class="text-right"
            icon
            small
          >
            <v-icon aria-label="Close" style="position: unset">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <validation-observer v-slot="{ handleSubmit }">
          <v-card-text class="py-0">
            <validation-provider
              v-slot="{ errors }"
              class="mb-2 w-100"
              name="Số điện thoại"
              :rules="{ regex: regex.isVNPhoneMobile, required: true, is_not: dataForm.customers[0].mobile }"
            >
              <v-text-field
                v-model="mobileMerge"
                :error-messages="errors"
                color="primary"
                class="i-cursor"
                placeholder="Nhập sđt chính ..."
              />
            </validation-provider>
          </v-card-text>
          <v-card-actions class="text-center py-3">
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              @click.prevent="handleSubmit(mergeContact)"
              height="30px"
            >
              Tiếp tục
            </v-btn>
          </v-card-actions>
        </validation-observer>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {maskedPhoneNumber} from "@/helpers/regex";
import RepositoryFactory from '../../../repositories/RepositoryFactory';
import {moduleSchoolLevel, moduleTypes, regex} from '../../../helpers/constants';
const AddressRepository = RepositoryFactory.get('address');
const ContactRepository = RepositoryFactory.get('contact')

export default {
  props: {
    contactColumns: {
      type: Object,
      default: () => ({}),
    },
    dataForm: {
      type: Object,
      default: () => {}
    },
    showChat: {
      type: Boolean,
      default: false
    },
    listPhoneRelated: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      provinces: [],
      districts: [],
      wards: [],
      regex,
      showMergeModal: false,
      mobileMerge: ''
    };
  },
  created() {
    this.getProvinces();
    if (this.dataForm.customers[0].tinhId) {
      this.getDistricts();
    }
    if (this.dataForm.customers[0].huyenId) {
      this.getWards();
    }
  },
  computed: {
    moduleTypes() {
      return moduleTypes
    },
    moduleSchoolLevel() {
      return moduleSchoolLevel
    },
    contactStatus() {
      return _.get(this.dataForm, 'contactStatus.type[0]', '');
    },
    contactColumnList() {
      return _.get(this.contactColumns, 'main_customer', []) || [];
    },
    stateModule() {
      return this.$store.state.module
    },
    computedFullName() {
      const module = this.$store.state.module;
      if (this.dataForm.customers[0].fullName === this.dataForm.customers[0].mobile) {
        if (module.typeId === moduleTypes.TU_HOC && module.schoolLevelId === moduleSchoolLevel.TH && this.contactStatus === 'M') {
          return maskedPhoneNumber(this.dataForm.customers[0].fullName);
        }
        return this.dataForm.customers[0].fullName;
      }
      return this.dataForm.customers[0].fullName;
    },
    computedPhoneNumber() {
      const module = this.$store.state.module;
      if (module.typeId === moduleTypes.TU_HOC && module.schoolLevelId === moduleSchoolLevel.TH && this.contactStatus === 'M') {
        return maskedPhoneNumber(this.dataForm.customers[0].mobile);
      }
      return this.dataForm.customers[0].mobile;
    },
  },
  methods: {
    maskedPhoneNumber,
    changePosition() {
      Bus.$emit('contact-change-postion');
    },
    onChangeDistrict() {
      if (this.dataForm.customers[0].huyenId) {
        this.dataForm.customers[0].xaId = 0;
        this.wards = [];
        this.getWards();
      }
    },
    onChangeProvince() {
      if (this.dataForm.customers[0].tinhId) {
        this.dataForm.customers[0].huyenId = 0;
        this.dataForm.customers[0].xaId = 0;
        this.districts = [];
        this.wards = [];
        this.getDistricts();
      }
    },
    async getProvinces() {
      const loader = this.$loading.show();
      const respond = await AddressRepository.provinces({ limit: 100 });
      loader.hide();
      if (_.get(respond, 'success', false)) {
        this.provinces = _.get(respond, 'data', []);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    async getDistricts() {
      const loader = this.$loading.show();
      const respond = await AddressRepository.districts(
        { limit: 100 },
        this.dataForm.customers[0].tinhId
      );
      loader.hide();
      if (_.get(respond, 'success', false)) {
        this.districts = _.get(respond, 'data', []);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    async getWards() {
      const loader = this.$loading.show();
      const respond = await AddressRepository.wards(
        { limit: 100 },
        this.dataForm.customers[0].tinhId,
        this.dataForm.customers[0].huyenId
      );
      loader.hide();
      if (_.get(respond, 'success', false)) {
        this.wards = _.get(respond, 'data', []);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    async mergeContact() {
      let self = this
      this.$swal({
        title: 'Xác nhận gộp contact ' + self.dataForm.customers[0].mobile + '<br>vào contact ' + self.mobileMerge,
        confirmButtonText: 'Đồng ý',
        showCancelButton: true,
        cancelButtonText: 'Hủy'
        },
      ).then(async (res) => {
        if(res.value) {
          let params = {
            sub_contact_id: self.dataForm.customers[0].contactId,
            main_phone: self.mobileMerge
          }
          let response =  await ContactRepository.mergeContact(params)
          if (response.success) {
            self.showMergeModal = false
            self.mobileMerge = ''
            Bus.$emit('merge-contact')
          } else {
            if (response.status == 500) {
              self.$swal({
                title: 'Contact ' + self.mobileMerge + ' đã được gộp vào contact ' + response.errors.id + '.<br>Bạn có muốn gộp vào contact ' + response.errors.id + '?',
                confirmButtonText: 'Đồng ý',
                showCancelButton: true,
                cancelButtonText: 'Hủy'
                },
              ).then(async (res) => {
                if(res.value) {
                  let params = {
                    sub_contact_id: self.dataForm.customers[0].contactId,
                    main_phone: response.errors.id
                  }
                  let response2 =  await ContactRepository.mergeContact(params)
                  if (response2.success) {
                    self.showMergeModal = false
                    self.mobileMerge = ''
                    Bus.$emit('merge-contact')
                  } else {
                    self.$swal({
                      type: 'error',
                      title: 'Lỗi !',
                      text: _.get(response2, 'message', '')
                    })
                  }
                }
              })
            } else {
              self.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(response, 'message', '')
              })
            }
          }
        }
      })
    },
    unmergeContact() {
      let self = this
      let title = ''
      if (this.dataForm.contactType == 'main') {
        title = "Xác nhận bỏ gộp contacts " + self.dataForm.phoneRelated.join(", ") + "<br>vào contact " + self.dataForm.customers[0].mobile
      } else if (this.dataForm.contactType == 'sub') {
        title = "Xác nhận bỏ gộp contact " + self.dataForm.customers[0].mobile + "<br>vào contact " + self.dataForm.phoneRelated[0]
      }
      this.$swal({
        title: title,
        confirmButtonText: 'Đồng ý',
        showCancelButton: true,
        cancelButtonText: 'Hủy',
        width: '500px'
      }).then(async (res) => {
        if (res.value) {
          let params = {
            contact_id: self.dataForm.id,
            contact_type: self.dataForm.contactType
          }
          let response = await ContactRepository.unmergeContact(params)
          if (response.success) {
            Bus.$emit('merge-contact')
          } else {
            self.$swal({
              type: 'error',
              title: 'Lỗi !',
              text: _.get(response, 'message', '')
            })
          }
        }
      })
    },
    showMainContact() {
      if (this.dataForm.contactType == 'sub') {
        let routeData = this.$router.resolve({
          name: 'ContactDetail',
          params: {
            id: this.dataForm.mainId || 0
          }
        })
        window.open(routeData.href, '_blank')
      }
    }
  }
};
</script>

<style scoped>
.merge-contact-btn {
  float: right;
  transform: translate(0px, -15px);
  font-size: 12px;
  text-decoration: underline;
  text-underline-position: under;
  cursor: pointer;
}
</style>
